// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7100736b","81":"22cc6cfd","84":"4f08fa4d","111":"7981a26e","297":"126b2479","411":"de1c542b","449":"74a9260a","650":"4c083d01","787":"b1de299e","895":"480f86bb"}[chunkId] + ".chunk.js";
};